module.exports = Ember.Component.extend()
